module.exports = __webpack_public_path__ + "static/media/dashboard_facebook_icon.45233543.svg";